(ns frontend.view.reports.custom.alj-2.active-deals-per-bu-and-stage-table
  (:require
   [common.entity :as entity]
   [reagent.core :as r]
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.state.current-session :as session]
   [frontend.utils :as fu]
   [frontend.view.reports.custom.alj :as alj]
   [frontend.view.reports.custom.alj-2.alj-components :as alj-components]
   [frontend.view.reports.custom.alj-2.utils :as alj-utils]))

(defn row-data
  [active-stages oppos label]
  (concat [label (count oppos)]
          (->> active-stages
               (map (fn [stage]
                      (let [stage-id (:db/id stage)]
                        (->> oppos
                             (cu/filter-by :oppo/stage stage-id)
                             (count)))))
               (doall))))

(defn report
  [{:keys [state]}]
  (let [date-state-atom (alj-utils/date-state-defaults
                         state
                         [[:date-created #{:entity.type/oppo} [:entity.type/oppo]]])]
    (fn [{:keys [state]}]
      (let [active-deals (->> (alj/all-deals)
                              (cu/filter-by :oppo/status :oppo.status/ok)
                              (alj-utils/deals-in-date-range-if-configured :common/created-on @date-state-atom :date-created :entity.type/oppo))
            report-pipeline-id (alj/alj-report-pipeline-id)
            active-stages (->> @session/all-stages
                               (remove :common/disabled?)
                               (cu/filter-by :stage/pipeline report-pipeline-id))
            active-business-units (session/non-archived-named-values :oppo/group-business-units (alj/alj-report-pipeline-id))
            active-business-unit-ids (->> active-business-units
                                          (map :db/id)
                                          (set))
            oppos-by-business-unit (->> active-deals
                                        (mapcat (fn [oppo]
                                                  (->> oppo
                                                       :oppo/group-business-units
                                                       (map (fn [bu-id]
                                                              [bu-id oppo])))))
                                        (group-by first)
                                        (map (fn [[bu-id bu-id-oppos]]
                                               [bu-id
                                                (->> bu-id-oppos
                                                     (map second)
                                                     (doall))]))
                                        (into {}))
            business-units-deals-data (->> active-business-units
                                           (map (fn [bu]
                                                  (let [bu-oppos (get oppos-by-business-unit (:db/id bu))]
                                                    (row-data active-stages bu-oppos (entity/display-string bu)))))
                                           (sort-by second)
                                           (reverse))
            oppos-without-active-bu (->> active-deals
                                         (remove (fn [oppo]
                                                   (some active-business-unit-ids (:oppo/group-business-units oppo)))))
            no-active-bu-data (when (seq oppos-without-active-bu)
                                (row-data active-stages oppos-without-active-bu (loc/tr :oppos-without-active-group-business-unit)))
            duplicate-bus (->> active-deals
                               (filter (fn [oppo]
                                         (> (count (:oppo/group-business-units oppo)) 1))))
            duplicate-bus-data (when (seq duplicate-bus)
                                 (row-data active-stages duplicate-bus (loc/tr :oppos-with-duplicate-business-units)))]
        [alj-components/alj-card
         {:view-name       (loc/tr :active-deals-per-business-unit-and-stage)
          :report-data     business-units-deals-data
          :date-state-atom date-state-atom
          :view            [:table.alj-report.zap-simple-table
                            [:thead
                             [:tr
                              [:th "SBU"]
                              [:th (loc/tr :total-number-of-deals)]
                              (->> active-stages
                                   (map-indexed (fn [idx stage]
                                                  ^{:key (str "alj-2-active-stages-per-bu-and-stage-" idx)}
                                                  [:th (fu/resolve-name stage)])))]]
                            [:tbody
                             (->>
                              business-units-deals-data
                              (map-indexed (fn [idx row-data]
                                             ^{:key (str "alj-2-total-deals-per-business-units-" idx)}
                                             [:tr
                                              {:class-name "alj-data-row"}
                                              (->> row-data
                                                   (map-indexed (fn [cell-idx cell-data]
                                                                  (let [no-data? (= 0 cell-data)]
                                                                    ^{:key (str "alj-2-total-deals-per-business-units-" idx "-" cell-idx)}
                                                                    [:td
                                                                     {:class-name (fu/cs (when-not (= cell-idx 0)
                                                                                           "number-cell")
                                                                                         (when no-data?
                                                                                           "empty-cell")
                                                                                         (when (= cell-idx 1)
                                                                                           "highlight-cell"))}
                                                                     (if no-data?
                                                                       "-"
                                                                       (str cell-data))])))
                                                   (doall))]))
                              (doall))]
                            [:tfoot
                             [:tr.alj-totals-row
                              (->> (row-data active-stages active-deals (loc/tr :grand-total))
                                   (map-indexed (fn [cell-idx cell-data]
                                                  ^{:key (str "alj-2-total-deals-per-business-units-totals-" cell-idx)}
                                                  [:td
                                                   {:class-name (fu/cs (when-not (= cell-idx 0)
                                                                         "number-cell"))}
                                                   (str cell-data)]))
                                   (doall))]
                             (when no-active-bu-data                ;; What does customer want to do with this?
                               [:tr.alj-error-row
                                (->> no-active-bu-data
                                     (map-indexed (fn [cell-idx cell-data]
                                                    ^{:key (str "alj-2-total-deals-per-business-units-unknown-bus-" cell-idx)}
                                                    [:td
                                                     {:class-name (fu/cs (when-not (= cell-idx 0)
                                                                           "number-cell"))}
                                                     (str cell-data)]))
                                     (doall))])
                             (when duplicate-bus-data               ;; What does customer want to do with this?
                               [:tr.alj-duplicate-row
                                (->> duplicate-bus-data
                                     (map-indexed (fn [cell-idx cell-data]
                                                    ^{:key (str "alj-2-total-deals-per-business-units-duplicate-bus-" cell-idx)}
                                                    [:td
                                                     {:class-name (fu/cs (when-not (= cell-idx 0)
                                                                           "number-cell"))}
                                                     (str cell-data)]))
                                     (doall))])]]}]))))
